var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import View from "./ui/view";
import { useDispatch } from "react-redux";
import { columns, getColumnsHistory } from "./resources/insurancePoliciesDTO";
import { quoteAll, quoteAllClearData } from "../../store/generateQuote/actions";
import { useNavigate, useParams } from "react-router-dom";
import { FormControl, InputLabel, MenuItem as MuiMenuItem, Select, } from "@mui/material";
import { ModalAFY, Positon, typeAlert, variants, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { breadcrumDTO } from "../../dataBase/layout";
import LocalStorageService from "../../services/localStorage";
import * as catalogConst from "../../const/catalog";
import { plan } from "../../store/plan/actions";
import { getHeader } from "../../resources/headers";
import { handleUnauthorized } from "../../resources/fetchRequest";
import { deleteEntityClearData } from "../../store/delete/actions";
import { cancelQuoteClearData } from "../../store/cancelQuote/actions";
import { policyCancelClearData } from "../../store/policy/actions";
import { useStyles } from "./assets/style";
import { getCatalogStatusQuote, getCatalogsTypeClearData, } from "../../store/catalog/actions";
import { formattedDate } from "../../utils/date";
import { sponsor } from "../../store/sponsor/actions";
import { Branches } from "../../store/branches/actions";
import { showErrorToast } from "../../fnx/showError";
import { useTranslation } from "react-i18next";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { Steps } from "../../enum/steps";
import { InsurancePoliciesHeader } from "./ui/header";
import useSelectors from "./components/selectors";
import useUI from "./components/ui";
import useInsurancePoliciesSummary from "./components/insurancePoliciesSummary";
import { GetCatalogsType } from "../../fnx/catalog/getCatalogsType";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var storageKey = "afy-steps";
var localStorageService = new LocalStorageService(storageKey);
var InsurancePoliciesSummary = function () {
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _a = React.useState(false), openModalUpdate = _a[0], setOpenModalUpdate = _a[1];
    var _b = React.useState(""), selectedQuoteStatus = _b[0], setSelectedQuoteStatus = _b[1];
    var classes = useStyles();
    var navigate = useNavigate();
    var id = useParams().id;
    var _c = React.useState(true), enable = _c[0], setEnable = _c[1];
    var _d = React.useState(1), page = _d[0], setPage = _d[1];
    var _e = React.useState([]), dataHistory = _e[0], setDataHistory = _e[1];
    var _f = React.useState(100), limit = _f[0], setLimit = _f[1];
    var _g = useState([]), rows = _g[0], setRows = _g[1];
    var _h = React.useState([]), breadCrumbs = _h[0], setBreadCrumbs = _h[1];
    var _j = React.useState(false), openModal = _j[0], setOpenModal = _j[1];
    var _k = React.useState(false), openModalHistorial = _k[0], setOpenModalHistorial = _k[1];
    var _l = React.useState("Póliza"), modalTitle = _l[0], setModalTitle = _l[1];
    var _m = React.useState(false), openModalConfirm = _m[0], setOpenModalConfirm = _m[1];
    var _o = React.useState([]), reasonCancellation = _o[0], setReasonCancellation = _o[1];
    var _p = React.useState(""), policyId = _p[0], setPolicyId = _p[1];
    var _q = React.useState(true), type = _q[0], setType = _q[1]; //cotizacion = false o poliza = true
    var _r = React.useState({}), row = _r[0], setRow = _r[1];
    var _s = useState([]), statusOptions = _s[0], setStatusOptions = _s[1];
    var _t = useState([]), insuranceOptions = _t[0], setInsuranceOptions = _t[1];
    var _u = useState([]), branchesOptions = _u[0], setBranchesOptions = _u[1];
    var _v = React.useState(""), sponsorId = _v[0], setSponsorId = _v[1];
    var _w = React.useState(""), idCatalogStatusQuote = _w[0], setIdCatalogStatusQuote = _w[1];
    var _x = useState(false), trigger = _x[0], setTrigger = _x[1];
    var _y = useState(false), triggerCatalogs = _y[0], setTriggerCatalog = _y[1];
    var _z = React.useState(""), dateStart = _z[0], setDateStart = _z[1];
    var _0 = React.useState(""), dateEnd = _0[0], setDateEnd = _0[1];
    var _1 = React.useState(false), isLoadin = _1[0], setIsLoading = _1[1];
    var _2 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _2[0], setSeeToast = _2[1];
    var _3 = useState(""), nameSearch = _3[0], setNameSearch = _3[1];
    var _4 = React.useState(""), selectedBranches = _4[0], setSelectedBranches = _4[1];
    var _5 = React.useState(""), selectedProjects = _5[0], setSelectedProjects = _5[1];
    var buildQuoteAllParams = React.useCallback(function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        var params = {
            clientId: clientId,
            enable: enable,
            page: page,
            limit: limit,
        };
        var hasOwn = Object.prototype.hasOwnProperty;
        var statuses = hasOwn.call(overrides, "statuses")
            ? overrides.statuses
            : idCatalogStatusQuote;
        if (statuses) {
            params.statuses = statuses;
        }
        var start = hasOwn.call(overrides, "creationDateStart")
            ? overrides.creationDateStart
            : dateStart;
        if (start) {
            params.creationDateStart = start;
        }
        var end = hasOwn.call(overrides, "creationDateEnd")
            ? overrides.creationDateEnd
            : dateEnd;
        if (end) {
            params.creationDateEnd = end;
        }
        var branches = hasOwn.call(overrides, "branches")
            ? overrides.branches
            : selectedBranches;
        if (branches) {
            params.branches = branches;
        }
        var projects = hasOwn.call(overrides, "projectIds")
            ? overrides.projectIds
            : selectedProjects;
        if (projects) {
            params.projectIds = projects;
        }
        var searchValue = hasOwn.call(overrides, "search")
            ? overrides.search
            : nameSearch;
        if (searchValue || searchValue === "") {
            params.search = searchValue;
        }
        if (hasOwn.call(overrides, "page")) {
            params.page = overrides.page;
        }
        if (hasOwn.call(overrides, "limit")) {
            params.limit = overrides.limit;
        }
        return params;
    }, [
        clientId,
        enable,
        page,
        limit,
        idCatalogStatusQuote,
        dateStart,
        dateEnd,
        selectedBranches,
        selectedProjects,
        nameSearch,
    ]);
    var fetchQuotes = React.useCallback(function (overrides) {
        if (overrides === void 0) { overrides = {}; }
        dispatch(quoteAll(buildQuoteAllParams(overrides)));
    }, [dispatch, buildQuoteAllParams]);
    var fields = "numberId,code,policyId.code,productId.description,clientId.description,firstNameA,firstNameB,lastNameA,lastNameB,catalogStatusQuote.description,catalogCancellation.createdAt,catalogCancellation.description";
    var labelFields = "Número documento,Cotización,Póliza,Producto,Aseguradora,Primer nombre,Segundo nombre,Primer apellido,Segundo apellido,Estatus,Fecha de cancelación,Motivo de cancelación";
    var _6 = useSelectors(clientId, trigger, sponsorId), responseCancelPolicy = _6.responseCancelPolicy, loadingCancelPolicy = _6.loadingCancelPolicy, errorCancelPolicy = _6.errorCancelPolicy, errorDeleteEntity = _6.errorDeleteEntity, responseCancelQuote = _6.responseCancelQuote, loadingCancelQuote = _6.loadingCancelQuote, responsePlan = _6.responsePlan, errorPlan = _6.errorPlan, responseProject = _6.responseProject, errorProject = _6.errorProject, responseGetCatalogStatusQuote = _6.responseGetCatalogStatusQuote, errorGetCatalogStatusQuote = _6.errorGetCatalogStatusQuote, responseAllQuote = _6.responseAllQuote, errorAllQuote = _6.errorAllQuote, loadingAllQuote = _6.loadingAllQuote, responseBranches = _6.responseBranches, errorBranches = _6.errorBranches, responseOneQuote = _6.responseOneQuote, responseSponsor = _6.responseSponsor, errorSponsor = _6.errorSponsor, responseInsurance = _6.responseInsurance;
    var _7 = useUI(setOpenModal, setOpenModalConfirm, setOpenModalHistorial), handleOpenModal = _7.handleOpenModal, handleCloseModal = _7.handleCloseModal, handleOpenModalConfirm = _7.handleOpenModalConfirm, handleCloseModalConfirm = _7.handleCloseModalConfirm, handleConfirm = _7.handleConfirm;
    var onUpdateConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("Policy ID to update:", policyId);
                    console.log("Selected quote status:", selectedQuoteStatus);
                    setOpenModalUpdate(false);
                    if (!policyId || !selectedQuoteStatus) {
                        showToastSuccessMessage("Seleccione un estado.", typeAlert.warning, setSeeToast);
                        console.error("Policy ID or selected status is missing");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updatePolicyStatus(policyId, selectedQuoteStatus)];
                case 2:
                    response = _a.sent();
                    showToastSuccessMessage("Actualizado correctamente", typeAlert.info, setSeeToast);
                    // Refresh the data after successful update
                    getQuoteAll();
                    setSelectedQuoteStatus(""); // Reset the selected status
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    showToastSuccessMessage("Error al actualizar", typeAlert.error, setSeeToast);
                    console.error("Failed to update policy status:", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onUpdateCancel = function () {
        setOpenModalUpdate(false);
        setSelectedQuoteStatus(""); // Reset the selected status
    };
    var handleStatusChange = function (event) {
        setSelectedQuoteStatus(event.target.value);
    };
    var updatePolicyStatus = function (policyId, catalogStatus) { return __awaiter(void 0, void 0, void 0, function () {
        var apiUrl, requestBody, requestOptions, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiUrl = "".concat(process.env.REACT_APP_HOST_API, "/asg/Api/V1/Policy/").concat(policyId, "/status");
                    requestBody = {
                        data: {
                            catalogStatus: catalogStatus,
                        },
                    };
                    requestOptions = {
                        method: "PATCH",
                        body: JSON.stringify(requestBody),
                        headers: getHeader(),
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, fetch(apiUrl, requestOptions)];
                case 2:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    handleUnauthorized(response.status);
                    return [4 /*yield*/, response.json()];
                case 3: throw _a.sent();
                case 4: return [4 /*yield*/, response.json()];
                case 5: return [2 /*return*/, _a.sent()];
                case 6:
                    error_2 = _a.sent();
                    console.error("Error updating policy status:", error_2);
                    throw error_2;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var activatePolicy = function (policyId) {
        if (!policyId) {
            showToastSuccessMessage("ID de póliza no válido", typeAlert.error, setSeeToast);
            console.error("Invalid policy ID");
            return;
        }
        setOpenModalUpdate(true);
        console.log("Policy ID to activate:", policyId);
        setPolicyId(policyId);
    };
    var _8 = useInsurancePoliciesSummary(setIdCatalogStatusQuote, setDateStart, setDateEnd, clientId, enable, page, limit, nameSearch, setIsLoading, idCatalogStatusQuote, dateStart, dateEnd, fields, labelFields, setSeeToast, setBranchesOptions, showToastSuccessMessage, setNameSearch, setSelectedBranches, setSelectedProjects, setPage, fetchQuotes, setInsuranceOptions, setStatusOptions, setRows, responseInsurance, localStorageService, navigate, Steps, setModalTitle, setPolicyId, setType, setOpenModal, setRow, setOpenModalConfirm, type, policyId, activatePolicy), filterStatus = _8.filterStatus, onClickDownload = _8.onClickDownload, getQuoteAll = _8.getQuoteAll, searchFilter = _8.searchFilter, getQuoteStatus = _8.getQuoteStatus, onCloseSearch = _8.onCloseSearch, setBranchesOptionsStorybook = _8.setBranchesOptionsStorybook, setInsuranceOptionsStorybook = _8.setInsuranceOptionsStorybook, setStatusOptionsStorybook = _8.setStatusOptionsStorybook, setDataQuoteStorybook = _8.setDataQuoteStorybook, filterData = _8.filterData, handleClickContextMenu = _8.handleClickContextMenu, handleCancelPolicy = _8.handleCancelPolicy;
    var _9 = GetCatalogsType(triggerCatalogs, enable, page, limit, catalogConst.CATALOG_REASON_CANCELLATION), responseGetCatalogsType = _9.responseGetCatalogsType, loadingGetCatalogsType = _9.loadingGetCatalogsType, errorGetCatalogsType = _9.errorGetCatalogsType;
    useEffect(function () {
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            if (Array.isArray(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
                var formattedResponse = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data.map(function (hItem) {
                    return __assign(__assign({}, hItem), { fechaCarga: formattedDate(hItem.fechaCarga) });
                });
                setDataHistory(formattedResponse);
                setOpenModalHistorial(true);
            }
        }
    }, [responseOneQuote]);
    useEffect(function () {
        setBreadCrumbs(breadcrumDTO());
        dispatch(quoteAllClearData());
        if (!responseAllQuote && id !== "pendientes") {
            console.log("Fetching all quotes");
            getQuoteAll();
        }
        if (!responseBranches) {
            dispatch(Branches({
                enable: enable,
                page: page,
                limit: limit,
                clientId: clientId,
            }));
        }
        if (!responseSponsor) {
            dispatch(sponsor({
                enable: enable,
                page: page,
                limit: limit,
                clientId: clientId,
            }));
        }
        setTriggerCatalog(true);
        if (!responsePlan) {
            dispatch(plan({ enable: enable, page: page, limit: 500 }));
        }
        if (!responseGetCatalogStatusQuote) {
            dispatch(getCatalogStatusQuote({ enable: enable, page: page, limit: limit }));
        }
        dispatch(deleteEntityClearData());
    }, []);
    useEffect(function () {
        var _a;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            if (Array.isArray(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
                var formattedResponse = (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _a === void 0 ? void 0 : _a.map(function (hItem) {
                    return __assign(__assign({}, hItem), { fechaCarga: formattedDate(hItem.fechaCarga) });
                });
                setDataHistory(formattedResponse);
                setOpenModalHistorial(true);
            }
        }
    }, [responseOneQuote]);
    useEffect(function () {
        if (errorCancelPolicy) {
            showErrorToast(errorCancelPolicy, setSeeToast, t);
        }
    }, [errorCancelPolicy]);
    useEffect(function () {
        if (errorGetCatalogsType) {
            showErrorToast(errorGetCatalogsType, setSeeToast, t);
        }
    }, [errorGetCatalogsType]);
    useEffect(function () {
        if (errorDeleteEntity) {
            showErrorToast(errorDeleteEntity, setSeeToast, t);
        }
    }, [errorDeleteEntity]);
    useEffect(function () {
        if (errorSponsor) {
            showErrorToast(errorSponsor, setSeeToast, t);
        }
    }, [errorSponsor]);
    useEffect(function () {
        if (errorPlan) {
            showErrorToast(errorPlan, setSeeToast, t);
        }
    }, [errorPlan]);
    useEffect(function () {
        if (errorProject) {
            showErrorToast(errorProject, setSeeToast, t);
        }
    }, [errorProject]);
    useEffect(function () {
        if (errorGetCatalogStatusQuote) {
            showErrorToast(errorGetCatalogStatusQuote, setSeeToast, t);
        }
    }, [errorGetCatalogStatusQuote]);
    useEffect(function () {
        if (errorAllQuote) {
            showErrorToast(errorAllQuote, setSeeToast, t);
        }
    }, [errorAllQuote]);
    useEffect(function () {
        if (errorBranches) {
            showErrorToast(errorBranches, setSeeToast, t);
        }
    }, [errorBranches]);
    useEffect(function () {
        if (responseCancelQuote) {
            showToastSuccessMessage("Cotizacion eliminada correctamente", typeAlert.success, setSeeToast);
            fetchQuotes();
            dispatch(quoteAllClearData());
            dispatch(cancelQuoteClearData());
        }
    }, [responseCancelQuote, fetchQuotes]);
    useEffect(function () {
        if (responseCancelPolicy && responseCancelPolicy.data) {
            showToastSuccessMessage("Póliza cancelada correctamente", typeAlert.success, setSeeToast);
            dispatch(quoteAllClearData());
            fetchQuotes();
            dispatch(policyCancelClearData());
        }
    }, [responseCancelPolicy, fetchQuotes]);
    useEffect(function () {
        var listSponsorFilter = "";
        responseSponsor === null || responseSponsor === void 0 ? void 0 : responseSponsor.map(function (sponsor, idx) {
            if (sponsor.id) {
                listSponsorFilter += "&sponsorId=".concat(sponsor.id);
            }
        });
        setSponsorId(listSponsorFilter);
    }, [responseSponsor]);
    useEffect(function () {
        if (Array.isArray(responseGetCatalogsType)) {
            var newArray = responseGetCatalogsType.map(function (item) { return ({
                id: item.id,
                value: item.id,
                name: item.description,
            }); });
            setReasonCancellation(newArray);
            dispatch(getCatalogsTypeClearData());
            setTriggerCatalog(false);
        }
    }, [responseGetCatalogsType]);
    useEffect(function () {
        if (Array.isArray(responseAllQuote)) {
            setDataQuoteStorybook(responseAllQuote);
        }
    }, [responseAllQuote]);
    useEffect(function () {
        if (Array.isArray(responseGetCatalogStatusQuote)) {
            setStatusOptionsStorybook(responseGetCatalogStatusQuote);
        }
    }, [responseGetCatalogStatusQuote]);
    useEffect(function () {
        if (Array.isArray(responseInsurance)) {
            setInsuranceOptionsStorybook(responseInsurance);
        }
    }, [responseInsurance]);
    useEffect(function () {
        if (Array.isArray(responseBranches)) {
            setBranchesOptionsStorybook(responseBranches);
        }
    }, [responseBranches]);
    useEffect(function () {
        setBreadCrumbs(breadcrumDTO());
        if (!responseProject) {
        }
    }, [responseSponsor]);
    useEffect(function () {
        if (nameSearch) {
            getQuoteAll();
        }
        else {
            onCloseSearch();
        }
    }, [nameSearch]);
    var onChangePage = function (page) {
        setPage(page);
    };
    var onChangeRowsPerPage = function (limit) {
        setLimit(limit);
        setPage(1);
    };
    useEffect(function () {
        getQuoteAll();
    }, [page, limit]);
    // Filter by "pendiente" status when URL param id equals "pendientes"
    useEffect(function () {
        if (id === "pendientes") {
            // Find the "pendiente" status option and set it as filter
            console.log("ID is pendientes", statusOptions);
            var pendienteStatus = statusOptions.find(function (status) {
                var _a, _b;
                return ((_a = status.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes("pendiente")) ||
                    ((_b = status.value) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes("pendiente"));
            });
            if (pendienteStatus) {
                console.log("Pendiente status found:", pendienteStatus);
                setIdCatalogStatusQuote(pendienteStatus.id || pendienteStatus.value || "");
                pendienteStatus.active = true;
                // Trigger the filter application
                getQuoteStatus(pendienteStatus.id);
            }
        }
    }, [id, statusOptions]);
    return (_jsxs(React.Fragment, { children: [_jsx(InsurancePoliciesHeader, { seeToast: seeToast, loading: loadingAllQuote ||
                    loadingCancelQuote ||
                    loadingCancelPolicy ||
                    isLoadin ||
                    loadingGetCatalogsType, setSeeToast: setSeeToast, isLoadin: isLoadin }), _jsx(ModalAFY, __assign({ openModal: openModalUpdate, onClose: onUpdateCancel, minWidthModal: "400px", title: "Confirmaci\u00F3n", positionButton: Positon.End, backgroundColorBackdrop: "#676767d1", backgroundColor: "#FFFFFF", name: "", buttonCancel: {
                    label: "Cancelar",
                    variant: variants.text,
                }, onSave: onUpdateConfirm, buttonAdd: {
                    label: "Aceptar",
                    variant: variants.contained,
                } }, { children: _jsx("div", __assign({ style: { padding: "20px" } }, { children: _jsxs("div", __assign({ style: { marginBottom: "10px" } }, { children: [_jsx("label", __assign({ style: {
                                    display: "block",
                                    marginBottom: "5px",
                                    fontWeight: "bold",
                                } }, { children: "Seleccione el estado de la cotizaci\u00F3n:" })), _jsxs(FormControl, __assign({ fullWidth: true, size: "small", variant: "outlined", style: { marginTop: "8px" } }, { children: [_jsx(InputLabel, __assign({ id: "quote-status-select-label" }, { children: "Estado" })), _jsx(Select, __assign({ labelId: "quote-status-select-label", id: "quote-status-select", value: selectedQuoteStatus, label: "Estado", onChange: handleStatusChange }, { children: statusOptions.map(function (option) { return (_jsx(MuiMenuItem, __assign({ value: option.value || option.id }, { children: option.name }), option.value || option.id)); }) }))] }))] })) })) })), _jsx(View, { onCloseSearch: onCloseSearch, searchFilter: searchFilter, columns: columns(handleClickContextMenu), getQuoteAll: getQuoteAll, getColumnsHistory: getColumnsHistory, filterStatus: filterStatus, rows: rows, insuranceOptions: insuranceOptions, statusOptions: statusOptions, branchOptions: branchesOptions, handleOpenModal: handleOpenModal, OpenModalHistorial: openModalHistorial, rowHistory: dataHistory, onClose: handleCloseModal, openModal: openModal, onConfirm: handleConfirm, reasonCancellation: reasonCancellation, handleOpenModalConfirm: handleOpenModalConfirm, onCloseConfirm: handleCloseModalConfirm, openModalConfirm: openModalConfirm, breadCrumbs: breadCrumbs, modalTitle: modalTitle, title: "Resumen pólizas", onSubmit: handleCancelPolicy, row: row, onClickDownload: onClickDownload, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage, limit: limit })] }));
};
export default InsurancePoliciesSummary;
